import React__default, { createContext, useContext } from 'react';

const defaultContextValue = {
  isTablist: false,
  size: 'base'
};
const TablistContext = /*#__PURE__*/createContext(defaultContextValue);
function TablistContextProvider({
  children,
  isTablist,
  size
}) {
  return /*#__PURE__*/React__default.createElement(TablistContext.Provider, {
    value: {
      isTablist,
      size
    }
  }, children);
}
const useTablistContext = () => {
  const {
    isTablist,
    size
  } = useContext(TablistContext);
  return {
    isTablist,
    size
  };
};

export { TablistContextProvider as T, useTablistContext as u };
//# sourceMappingURL=TablistContext-Bpw2P1bl.js.map
